enum AccessReportsAdminPageOptionsEnum{
  Default = "Default",
  Hide = "Hide",
  AllowMultiple = "Allow Multiple",
}

export { AccessReportsAdminPageOptionsEnum };
